<template lang="pug">
.sidebar(:data-color='backgroundColor')
  .sidebar-wrapper(ref='sidebarScrollArea')
    slot
    ul.nav
      slot(name='links')
        sidebar-item(v-for='(link, index) in sidebarLinks', :key='link.name + index', :link='link')
          sidebar-item(v-for='(subLink, index) in link.children', :key='subLink.name + index', :link='subLink')
</template>
<script>
export default {
  name: 'sidebar',
  props: {
    title: {
      type: String,
      default: 'Asia Alt'
    },
    backgroundColor: {
      type: String,
      default: 'black',
      validator: value => {
        let acceptedValues = [
          '',
          'blue',
          'azure',
          'green',
          'orange',
          'red',
          'purple',
          'black'
        ];
        return acceptedValues.indexOf(value) !== -1;
      }
    },
    logo: {
      type: String,
      default: 'img/icon-vue.png'
    },
    sidebarLinks: {
      type: Array,
      default: () => []
    },
    autoClose: {
      type: Boolean,
      default: true
    }
  },
  provide() {
    return {
      autoClose: this.autoClose
    };
  },
  methods: {
    minimizeSidebar() {
      if (this.$sidebar) {
      }
    }
  },
      mounted() {
        },
  beforeDestroy() {
    if (this.$sidebar.showSidebar) {
      this.$sidebar.showSidebar = false;
    }
  }
};
</script>
<style>

#app .sidebar .sidebar-wrapper> .nav, .off-canvas-sidebar .nav {
    margin-top: 43px;
    }
@media (min-width: 992px) {
  .navbar-search-form-mobile,
  .nav-mobile-menu {
    display: none;
  }
}
</style>
